/*
kavyareddy 02/2/2023 2699234404 Added Scheduler execution history search
kavyareddy 02/3/2023 2699234404 Fixed label issues
kavyareddy 03/1/2023 2699234404 Fixed payload issue and label issue
Dilip 02/09/2023 2699234404 added created for, created by dropdown
suresh peddavoora 02/21/2023 2699234404 New UI changes
Akhila 06/08/2023 2699234404 created date change to date created field and column
Ravi 06/08/2023 2699234404 rearrange search fields
Akhila 06/16/2023 2699234404 removed date created and created for from col and field
Prakash 19/06/2023 2699234404 fixed alignments issue in responsive
Prakash 22/06/2023 2789725780 fixed alignments issues data picker

*/
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Form, Formik} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import SchedulerSearchTable from '../SearchExecutionHistory/SchedulerSearchTable';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../redux/reducers/ReportMaster';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import {createdByOptions} from '../../../../util/CreatedByForOptions';

const SchedulerSearch = () => {
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchData, setSearchData] = useState({});
  const {createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const dispatch = useDispatch();
  const statuses = [{value: 'FAILED'}, {value: 'COMPLETED'}];
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchFlag(true);
    setSearchData(data);
  };
  const validationSchema = Yup.object().shape({
    // createdDate: Yup.date().typeError("Invalid date format").nullable(),
    endTime: Yup.date().typeError('Invalid date format').nullable(),
    startTime: Yup.date().typeError('Invalid date format').nullable(),
  });
  const initialValues = {
    jobCode: '',
    description: '',
    endTime: null,
    startTime: null,
    jobStatus: '',
    createdFor: '',
    isDraft: '',
    createdBy: '',
    createdDate: null,
  };

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('schedulerexecutionhistory'));
    dispatch(fetchCreatedForDropDownData('schedulerexecutionhistory'));
  }, [dispatch]);

  return (
    <div>
      <h2 className="search-title">Scheduler Execution History Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleReset, setFieldValue, handleBlur, errors, touched} =
            props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <div>
                  <ErrorBoundaryForComponents>
                    <div className="form-row standard-field-textfields new-standard-textfields">
                      <div className="col-md-4 col-lg-2 form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Job Name`}
                          className={` ${classes.labelName}`}
                          label="Job Name"
                          name="jobCode"
                          value={values?.jobCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.jobCode && errors.jobCode)}
                          fullWidth
                        />
                        <FormHelperText>
                          {touched?.jobCode && errors?.jobCode ? errors?.jobCode : ''}
                        </FormHelperText>
                      </div>
                      <div className=" col-md-4 col-lg-4 form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Job Description`}
                          label="Job Description"
                          className={` ${classes.labelName}`}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className=" col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          {...props}
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="jobStatus"
                          id="jobStatus"
                          size="small"
                          value={values.jobStatus}
                          options={statuses}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          required
                          onChange={(e, value) => {
                            setFieldValue('jobStatus', value);
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Execution Status"
                                placeholder="Select Execution Status"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdFor"
                          id="createdFor"
                          size="small"
                          value={values.createdFor}
                          options={createdForData}
                          getOptionLabel={(option) => {
                            return option ? option : "";
                          }}
                          onChange={(e, value) => {
                            setFieldValue("createdFor", value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created For"
                                placeholder="Select Created For"
                              />
                              <FormHelperText variant="outlined">
                                {touched.createdFor && errors.createdFor}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div> */}
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue("createdDate", val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ""}
                        </FormHelperText>
                      </div> */}
                      {/* <div className="col-md-4 col-lg-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          name="isDraft"
                          id="isDraft"
                          size="small"
                          options={StatusOptions}
                          required
                          value={values.isDraft}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue("isDraft", value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                // className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="standard"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div> */}
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.startTime}
                            name="startTime"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Start Date"
                            onChange={(val) => {
                              setFieldValue('startTime', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.startTime}
                            error={Boolean(touched?.startTime && errors?.startTime)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.startTime && errors.startTime ? errors.startTime : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.endTime}
                            name="endTime"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="End Date"
                            onChange={(val) => {
                              setFieldValue('endTime', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.endTime}
                            error={Boolean(touched?.endTime && errors?.endTime)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.endTime && errors.endTime ? errors.endTime : ''}
                        </FormHelperText>
                      </div>

                      <div className="col-md-12 col-lg-2 col-xl-2 form-group">
                        <div className="d-flex justify-content-md-center justify-content-xl-start justify-content-lg-start">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData({});
                              setSubmit(true);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <SchedulerSearchTable
        searchData={searchData}
        setSubmit={setSubmit}
        setSearchFlag={setSearchFlag}
        setSearchData={setSearchData}
        submit={submit}
        searchFlag={searchFlag}
      />
    </div>
  );
};

export default SchedulerSearch;
